import { requestFactory } from './index';
const request = requestFactory('/api/');
export function putRename(params) {
    return request({
        method: 'put',
        url: params.api,
        data: {
            name: params.name,
        },
    });
}
